<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-[600px] mx-auto bg-white border rounded-lg"
  >
    <div class="p-6 standard-form">
      <!-- hack to not focus the first input -->
      <div style="max-width: 0; max-height: 0; overflow: hidden;">
        <input autofocus="true" />
      </div>
      <!-- end hack -->
      <div class="pb-4 text-xl">Drop Church #{{ church.id }}</div>

      <div class="standard-field-wrapper">
        <label for="dropped_at">Drop Date</label>
        <div class="standard-input-wrapper">
          <div class="standard-input-container">
            <input type="text" name="dropped_at" ref="datepicker" v-model="date" class="datepicker">
          </div>
        </div>

        <label for="dropped_reason_text">Reason</label>
        <div class="standard-input-wrapper">
          <div class="standard-input-container">
            <textarea rows="6" name="dropped_reason_text" v-model="dropped_reason"></textarea>
          </div>
        </div>
      </div>

      <div class="flex flex-row justify-end mt-4">
        <button class="btn btn-primary mr-2" @click="dropChurch()">Drop</button>
        <button class="btn btn-secondary" @click="closeModal()">Cancel</button>
      </div>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import axios from 'axios'
  import flatpickr from 'flatpickr'
  import { onMounted, ref, reactive, computed } from 'vue'

  import { VueFinalModal } from 'vue-final-modal'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  let church = ref({})
  let date = ref('')
  let dropped_reason = ref('')
  let datepicker = ref()

  onMounted(() => {
    church.value = props.params.data.church

    let today = new Date()
    date.value = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`

    setUpDatePicker()
  })


  function setUpDatePicker () {
    let itvl = setInterval(() => {
      if (datepicker.value) {
        flatpickr(datepicker.value)
        clearInterval(itvl)
      }
    }, 50)
  }

  function closeModal () {
    emit("close")
  }

  async function dropChurch () {
    try {
      await axios.put(`/churches/${church.value.id}.json`, {
        state: 'dropped',
        dropped_at: date.value,
        dropped_reason_text: dropped_reason.value,
        dropped_explicitly: true,
        return_path: `/training_centers/${church.value.training_center_id}`,
      })
    } catch(err) {
      window.Rollbar.error('Failed to drop church', err )
      alert('Unable to drop Church')
    } finally {
      closeModal()
      location.reload(true)
    }
  }
</script>

<style>
  .vm--modal {
    overflow: initial !important;
  }

  .bold {
    font-weight: bold;
  }

  .pad {
    margin: 5px;
  }
</style>
